(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_evervoice-delivery-timeline"] && !Shopify.designMode) return;
  try {
    (() => {
    const dayFormatter = new Intl.DateTimeFormat('en-US', {
      month: 'short',
      day: 'numeric'
    });

    const addBusinessDays = (startDate, numberOfDays) => {
      const date = new Date(startDate);
      let daysAdded = 0;

      while (daysAdded < numberOfDays) {
        date.setDate(date.getDate() + 1);

        if (date.getDay() !== 0 && date.getDay() !== 6) {
          daysAdded += 1;
        }
      }

      return date;
    };

    const formatDateRange = (startDate, endDate) => {
      if (
        startDate.getFullYear() === endDate.getFullYear() &&
        startDate.getMonth() === endDate.getMonth()
      ) {
        const month = new Intl.DateTimeFormat('en-US', { month: 'short' }).format(startDate);
        return `${month} ${startDate.getDate()}–${endDate.getDate()}`;
      }

      return `${dayFormatter.format(startDate)}–${dayFormatter.format(endDate)}`;
    };

    const toDateTime = (date) => {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    };

    const updateTimeline = (timeline) => {
      const today = new Date();
      today.setHours(0, 0, 0, 0);

      const dates = {
        order: {
          label: `Today, ${dayFormatter.format(today)}`,
          start: today,
          end: today
        },
        processing: {
          label: formatDateRange(addBusinessDays(today, 1), addBusinessDays(today, 2)),
          start: addBusinessDays(today, 1),
          end: addBusinessDays(today, 2)
        },
        delivery: {
          label: `As early as ${dayFormatter.format(addBusinessDays(today, 7))}`,
          start: addBusinessDays(today, 7),
          end: addBusinessDays(today, 7)
        }
      };

      timeline.querySelectorAll('[data-evervoice-date]').forEach((dateElement) => {
        const dateValue = dates[dateElement.dataset.evervoiceDate];

        if (!dateValue) return;

        dateElement.textContent = dateValue.label;
        dateElement.setAttribute('datetime', toDateTime(dateValue.start));
        dateElement.setAttribute(
          'aria-label',
          dateValue.start.getTime() === dateValue.end.getTime()
            ? dateValue.label
            : `${dayFormatter.format(dateValue.start)} through ${dayFormatter.format(dateValue.end)}`
        );
      });
    };

    const updateAllTimelines = () => {
      document.querySelectorAll('[data-evervoice-delivery]').forEach(updateTimeline);
    };

    updateAllTimelines();
    document.addEventListener('shopify:section:load', updateAllTimelines);
    window.setInterval(updateAllTimelines, 60000);
  })();
  } catch(e) { console.error(e); }
})();

})();
